'use client';
import React from 'react';
import { LocaleType, LOCALES } from '@benzinga/translate';

import { BZHeaderKorea } from './global/BZHeaderKorea';
interface Props {
  locale?: LocaleType;
}

const LOCALE_HEADERS = {
  [LOCALES.JA]: BZHeaderKorea,
  [LOCALES.KO]: BZHeaderKorea,
};

export const BZHeader: React.FC<Props> = ({ locale }) => {
  const LocaleHeader = locale ? LOCALE_HEADERS[locale] : null;

  return (
    <>
      {/* <Fonts /> */}
      {LocaleHeader && <LocaleHeader />}
    </>
  );
};

// Next.js preloads fonts with localFont already
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Fonts = () => (
  <>
    <link
      as="font"
      crossOrigin="anonymous"
      href="/next-assets/fonts/manrope-v15-latin/manrope-v15-latin-300.woff2"
      rel="preload"
      type="font/woff2"
    />
    <link
      as="font"
      crossOrigin="anonymous"
      href="/next-assets/fonts/manrope-v15-latin/manrope-v15-latin-regular.woff2"
      rel="preload"
      type="font/woff2"
    />
    <link
      as="font"
      crossOrigin="anonymous"
      href="/next-assets/fonts/manrope-v15-latin/manrope-v15-latin-500.woff2"
      rel="preload"
      type="font/woff2"
    />
    <link
      as="font"
      crossOrigin="anonymous"
      href="/next-assets/fonts/manrope-v15-latin/manrope-v15-latin-600.woff2"
      rel="preload"
      type="font/woff2"
    />
    <link
      as="font"
      crossOrigin="anonymous"
      href="/next-assets/fonts/manrope-v15-latin/manrope-v15-latin-700.woff2"
      rel="preload"
      type="font/woff2"
    />
    <link
      as="font"
      crossOrigin="anonymous"
      href="/next-assets/fonts/manrope-v15-latin/manrope-v15-latin-800.woff2"
      rel="preload"
      type="font/woff2"
    />
  </>
);
